/* Catharsis: theme material and room for purchase controls. */
(() => {
  'use strict';
  const stylesheet=document.currentScript?.dataset.style;
  if(!stylesheet)return;
  const mobile=matchMedia('(max-width:749px)');
  let widgetHost,previewFrame,stickyElement,scheduled=false,frameId=0;
  function setOffset(name,value){
    const pixels=Math.round(value)+'px';
    if(widgetHost.style.getPropertyValue(name)!==pixels)widgetHost.style.setProperty(name,pixels);
  }
  function syncClearance(){
    scheduled=false;if(!widgetHost)return;
    const frame=previewFrame?.getBoundingClientRect();
    const visible=frame&&frame.height>0&&frame.top<innerHeight&&frame.bottom>0&&getComputedStyle(previewFrame).visibility!=='hidden';
    const preview=visible?Math.min(80,Math.ceil(innerHeight-frame.top)):0;
    // The mobile launcher has a stable dock. Only persistent fixed bars can lift it.
    // Never chase scrolling cards/buttons: their collision boundary made it jump 126px.
    if(mobile.matches){
      const base=innerWidth<481?18:22;
      const stickyVisible=stickyElement?.classList.contains('is-visible')&&stickyElement.getClientRects().length;
      const stickyTop=stickyVisible?stickyElement.offsetHeight+(parseFloat(getComputedStyle(stickyElement).bottom)||0)+12:0;
      setOffset('--clara-preview-offset',preview);
      setOffset('--clara-purchase-clearance',Math.max(0,stickyTop-preview-base));
      return;
    }
    let bottom=preview+(innerWidth<481?18:22);
    const right=document.documentElement.clientWidth-(innerWidth<481?16:22),left=right-54;
    const rects=[...document.querySelectorAll('.campaign-pick,.button,.quick-button,.fit-label,.brief-glass-button,.world-hotspot,.newsletter-input,.sticky-buy,.pagination,.footer-links a,.footer-base a,.footer-base button,.payment-methods,.about-cover-photo figcaption a,.product-return,.product-help,.full-details,.text-link,.album-controls button,.album-social,.gallery-toolbar button,.gallery-thumbnails a,.product-film-link,.play-enter,.play-teaser-toggle,.play-preview-controls button,.play-preview-caption,.play-originals,.paella-story-links a,.product-gallery .zoom-hint')]
      .filter(el=>el.getClientRects().length).map(el=>{
        const rect=el.getBoundingClientRect();
        if(el===stickyElement&&el.classList.contains('is-visible')){
          const bottom=innerHeight-(parseFloat(getComputedStyle(el).bottom)||0);
          return {left:rect.left,right:rect.right,top:bottom-el.offsetHeight,bottom};
        }
        return rect;
      }).filter(r=>r.left<right&&r.right>left&&r.bottom>0&&r.top<innerHeight).sort((a,b)=>b.top-a.top);
    for(const r of rects){
      const top=innerHeight-bottom-54,end=innerHeight-bottom;
      if(r.top<end+8&&r.bottom>top-8)bottom=Math.max(bottom,innerHeight-r.top+12);
    }
    setOffset('--clara-preview-offset',preview);
    setOffset('--clara-purchase-clearance',Math.min(Math.max(0,bottom-preview-22),innerHeight*.5));
  }
  function schedule(){if(!scheduled){scheduled=true;frameId=requestAnimationFrame(syncClearance);}}
  function watchScroll(){
    window.removeEventListener('scroll',schedule,true);
    if(!mobile.matches)window.addEventListener('scroll',schedule,{passive:true,capture:true});
    schedule();
  }
  const purchaseObserver=new MutationObserver(schedule);
  document.addEventListener('transitionend',event=>{if(event.target===stickyElement)schedule();});
  const resize=typeof ResizeObserver==='function'?new ResizeObserver(schedule):null;
  function connect(){
    if(!document.querySelector('script[data-brand="catharsis"]')){document.documentElement.removeAttribute('data-clara-dock');return;}
    if(!widgetHost?.isConnected){
      widgetHost=null;
      for(const host of document.body.children){
        const root=host.shadowRoot;if(!root?.querySelector('.launch .bubble'))continue;
        if(!root.querySelector('[data-cat-clara-style]')){const link=document.createElement('link');link.rel='stylesheet';link.href=stylesheet;link.dataset.catClaraStyle='';root.append(link);host.dataset.catClara='';}
        widgetHost=host;document.documentElement.setAttribute('data-clara-dock','');break;
      }
      if(!widgetHost)document.documentElement.removeAttribute('data-clara-dock');
    }
    const sticky=document.querySelector('.sticky-buy'),frame=document.getElementById('PBarNextFrame');
    if(sticky!==stickyElement||frame!==previewFrame){
      purchaseObserver.disconnect();resize?.disconnect();stickyElement=sticky;previewFrame=frame;
      [sticky,frame].filter(Boolean).forEach(element=>{
        purchaseObserver.observe(element,{attributes:true,attributeFilter:['class','style','hidden']});
        resize?.observe(element);
      });
    }
    schedule();
  }
  const observer=new MutationObserver(connect);
  function start(){
    stickyElement=undefined;previewFrame=undefined;connect();
    observer.observe(document.body,{childList:true});window.addEventListener('resize',schedule,{passive:true});
    mobile.addEventListener('change',watchScroll);watchScroll();
  }
  start();
  window.addEventListener('pagehide',()=>{
    observer.disconnect();purchaseObserver.disconnect();resize?.disconnect();cancelAnimationFrame(frameId);scheduled=false;
    window.removeEventListener('resize',schedule);window.removeEventListener('scroll',schedule,true);mobile.removeEventListener('change',watchScroll);
  });
  window.addEventListener('pageshow',event=>{if(event.persisted)start();});
})();
